import { WsAccountDetails } from '@model/ftf-api.model';
import { createAction, props } from '@ngrx/store';

export const loadAccountDetails = createAction('[Account] Load Account Details');

/**
 * Action dispatched when account details are successfully loaded.
 */
export const loadAccountDetailsSuccess = createAction(
  '[Account] Load Account Details Success',
  props<{
    accountDetails: WsAccountDetails;
  }>()
);

/**
 * Action dispatched when loading account details fails.
 */
export const loadAccountDetailsFailure = createAction(
  '[Account] Load Account Details Failure',
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props<{ error: any }>()
);

/**
 * Action to reset the account state.
 */
export const resetAccountState = createAction('[Account] Reset Account State');
